<template>
	<div class="display-flex flex-column flex-centerize">
		<Loader v-if="isLoading" small />
		<div v-else class="load-more-container width-100 display-flex flex-row pl-3 pr-6 flex-align-center flex-justify-space-between mt-2">
			<div class="results-description">{{ resultsDescription }}</div>
			<AppTooltip :disabled="hasMoreData" top :text="tooltipText">
				<AnemicButton :disabled="!hasMoreData" @click="loadMore" class="load-more-button" :class="{ disabled: !hasMoreData }">
					{{ 'Load more' }}
				</AnemicButton>
			</AppTooltip>
		</div>
	</div>
</template>

<script>
import AppTooltip from '@/components/common/AppTooltip';
export default {
	name: 'InsertDataLoadMore',
	components: {
		AppTooltip,
	},
	props: {
		isLoading: { type: Boolean },
		isFiltered: { type: Boolean },
		hasMoreData: { type: Boolean },
		totalItemsLength: { type: Number },
		totalItemsOnDisplay: { type: Number },
	},
	computed: {
		tooltipText() {
			return `Showing all possible results`;
		},
		resultsDescription() {
			if (this.isFiltered) {
				return this.isFilteredDescriptionText;
			} else {
				return this.regularDescriptionText;
			}
		},
		regularDescriptionText() {
			return `Showing the first ${this.totalItemsLength} results`;
		},
		isFilteredDescriptionText() {
			return `${this.totalItemsOnDisplay} results in the first ${this.totalItemsLength} items`;
		},
	},

	methods: {
		loadMore() {
			this.$emit('load-more');
		},
	},
};
</script>

<style scoped lang="scss">
.load-more-container {
	height: 37px;
	background: var(--button-background);
	border: 1px solid var(--border-color);
	box-shadow: 0px 3px 6px var(--shadow-color);

	.results-description {
		font-size: 12px;
		color: var(--load-more-text);
	}

	.load-more-button {
		width: 89px;
		height: 25px !important;
		color: var(--button-text);
		font-size: 12px !important;
		background: var(--bg-color);
		border: 1px solid var(--button-text);

		&.disabled {
			border: none;
		}
	}
}
</style>
